import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useServiceQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const useServiceQuery = (id) =>
        useQuery({
            queryKey: ["service", id],
            queryFn: ({ queryKey }) => {
                const [, categoryId] = queryKey;
                return axiosPrivate
                    .get(`service/${categoryId}/`)
                    .then((r) => r.data);
            },
            enabled: !!id, // prevents running until id exists
        });

    const useServiceCategoryQuery = (id) =>
        useQuery({
            queryKey: ["service", "get_for_category", id],
            queryFn: ({ queryKey }) => {
                const [, , categoryId] = queryKey;
                return axiosPrivate
                    .get(`service/${categoryId}/get_for_category/`)
                    .then((r) => r.data);
            },
            enabled: !!id, // prevents running until id exists
        });


    const serviceBusinessQuery = useQuery({
        queryFn: () =>
            axiosPrivate
                .get("service/get_for_business/")
                .then(r => r.data),
        queryKey: ["service", "get_for_business"],
    });

    // MUTATIONS ------------------------------------------------------

    const createServiceMutation = useMutation({
            mutationFn: (data) => axiosPrivate.post(`service/`, data, {headers: {"Content-Type": "multipart/form-data"}}).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["service"]);
            },
        });

    const updateServiceMutation = useMutation({
            mutationFn: ({id, data}) => axiosPrivate.patch(`service/${id}/`, data, {headers: {"Content-Type": "multipart/form-data"}}).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["service"]);
            },
        });

    const deleteServiceMutation = useMutation({
            mutationFn: id => axiosPrivate.delete(`service/${id}/`).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["service"]);
            },
        });



    return {
        useServiceCategoryQuery,
        serviceBusinessQuery,
        useServiceQuery,
        createServiceMutation,
        updateServiceMutation,
        deleteServiceMutation
    };
}
